import { useSchedulingQuery as useQuery } from "../../../../hooks/ReactQueryHooks/useSchedulingQuery";
import { schedulingGet } from "../../../api/Scheduling/client";

export async function fetchOverview(params, signal, consistency) {
  const response = await schedulingGet("schedule", {
    ...params, practitionerRefs: params.practitionerRefs?.join(","), serviceCategoryIds: params.serviceCategoryIds?.join(","),
  }, { signal, consistency });
  if (!Array.isArray(response?.practitioners) || !Array.isArray(response?.summaries) || !Array.isArray(response?.schedules) ||
      (params.overview === "details" && !["availability", "blocks", "appointments"].every(key => Array.isArray(response[key])))) {
    throw new Error("Could not load the schedule. Please try again.");
  }
  if (response.nextCursor != null && (typeof response.nextCursor !== "string" || response.nextCursor === params.cursor)) {
    throw new Error("Could not continue loading practitioners.");
  }
  const indexes = params.overview === "summary" ? [-1, 0, 1, 2, 3, 4, 5, 6] : [-1, 0];
  if (response.practitioners.length > params.limit || new Set(response.practitioners).size !== response.practitioners.length ||
      ![null, ...response.practitioners].every(ref => indexes.every(index => {
        const matches = response.summaries.filter(row => row.ref === ref && row.index === index);
        return matches.length === 1 && Array.isArray(matches[0].hours) && Array.isArray(matches[0].availableHours) &&
          ["workMinutes", "availableMinutes", "blockMinutes", "appointmentCount", "cancelledCount"].every(key => Number.isFinite(matches[0][key]) && matches[0][key] >= 0);
      }))) throw new Error("Could not load complete schedule summaries.");
  return response;
}
export default function useOverviewPage(params) {
  return useQuery(["scheduling-overview-page", params], ({ signal, consistency }) => fetchOverview(params, signal, consistency), {
    enabled: !!params.organizationRef, staleTime: 30000, cacheTime: 300000, keepPreviousData: false,
    refetchOnWindowFocus: false, retry: false,
  });
}
